var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpinsStar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 818,
    viewBox: "0 0 555 818",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.075 17.3458L296.002 264.797C297.182 271.385 301.593 277.088 307.824 280.115L542.015 390.794C557.695 398.257 558.324 419.682 542.902 427.173L313.918 537.84C307.79 540.795 303.611 546.522 302.804 553.166L271.461 800.559C269.359 817.21 248.449 823.8 236.012 811.805L51.5615 632.818C46.5868 628.02 39.6635 625.859 32.8429 626.976L-220.671 669.276C-237.722 672.067 -251.172 654.754 -243.43 639.863L-128.494 418.559C-125.379 412.635 -125.559 405.548 -128.918 399.632L-254.268 178.243C-262.692 163.31 -250.116 146.006 -232.847 148.827L22.7242 191.001C29.532 192.179 36.4038 189.997 41.16 185.126L217.048 6.10193C228.945 -5.86982 250.228 0.772486 253.075 17.3458Z",
    fill: "#41DAFD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpinsStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Spins_Star.7b884307f373f42e1471aeb0006626e9.svg";